import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Button,
    Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { IPrestacaoContasPagedResponse } from "models/response/prestacao-contas-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { getCategoryColor } from "utils/category-colors";

type PrestacaoContasTableProps = {
    currentItems: PaginationResponse<IPrestacaoContasPagedResponse>;
};

export const formatPeriodo = (indPeriodicidade: number, ano: number, periodo?: number | null, anoFim?: number | null): string => {
    switch (indPeriodicidade) {
        case 2: return periodo ? `${periodo}º Bimestre/${ano}` : `${ano}`;
        case 3: return periodo ? `${periodo}º Quadrimestre/${ano}` : `${ano}`;
        case 4: return anoFim ? `${ano}-${anoFim}` : `${ano}`;
        case 5: return periodo ? `${periodo}º Trimestre/${ano}` : `${ano}`;
        default: return `${ano}`;
    }
};

export const PrestacaoContasTable: React.FC<PrestacaoContasTableProps> = ({ currentItems }) => {
    const navigate = useNavigate();

    if (!currentItems?.hasItems()) {
        return <Typography variant="body1">Nenhum registro de prestação de contas encontrado.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Tipo de Documento</TableCell>
                        <TableCell>Período</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell align="center">Detalhes</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentItems.items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>
                                <Chip label={item.tipoDocumentoPrestacaoContasName} size="small" style={getCategoryColor(item.tipoDocumentoPrestacaoContasName)} />
                            </TableCell>
                            <TableCell>{formatPeriodo(item.indPeriodicidade, item.ano, item.periodo, item.anoFim)}</TableCell>
                            <TableCell>
                                <Chip
                                    label={item.indStatus === 2 ? 'Finalizado' : 'Em Execução'}
                                    size="small"
                                    color={item.indStatus === 2 ? 'primary' : 'default'}
                                />
                            </TableCell>
                            <TableCell>{item.textoDescricao}</TableCell>
                            <TableCell align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => navigate(`/prestacao-contas/${item.id}`)}
                                >
                                    Detalhes
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
